<template>
  <div id="ChargeSheetWork">
    <div class="row">
            <div class="col-12">
              <MdTitleRegInfo
                v-bind:RegistrationInfo="PatientTitle"
                v-bind:titlePrefix="$t('ChargeSheet.WorkSheet')"
                v-bind:IsClinical="false"
                v-bind:titleRef="'titleElementPatientClaim'"
                v-bind:patientCode="this.$route.params.id">
              </MdTitleRegInfo>
            </div>
    </div>

    <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
        <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">
            <div class="tab-pane fade show active" id="diag1_8" role="tabpanel">
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagVer')"
                            v-bind:Options="verOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="false"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="diagVerModel"
                            :Input="changeDiagVer"
                            :IsDisabled="true" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment1Model"
                            :Input="changeIPFComoAdjustment1"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment1Model"
                            :Input="changeIPFDrgAdjustment1"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="admittingCode"
                            v-bind:ModelDescription="admittingDescription"
                            v-bind:Label="$t('ChargeSheet.Admitting')"
                            v-bind:RefCode="'Admitting'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.Admitting')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode1"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA1Model"
                            :Input="changePOA1"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ1'"
                            v-bind:TypeProp="'text'"
                            v-model="adj1Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment2Model"
                            :Input="changeIPFComoAdjustment2"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment2Model"
                            :Input="changeIPFDrgAdjustment2"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="primaryCode"
                            v-bind:ModelDescription="primaryDescription"
                            v-bind:Label="$t('ChargeSheet.Primary')"
                            v-bind:RefCode="'Primary'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.Primary')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode2"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA2Model"
                            :Input="changePOA2"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ2'"
                            v-bind:TypeProp="'text'"
                            v-model="adj2Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment3Model"
                            :Input="changeIPFComoAdjustment3"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment3Model"
                            :Input="changeIPFDrgAdjustment3"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis1Code"
                            v-bind:ModelDescription="otherDiagnosis1Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis1')"
                            v-bind:RefCode="'OtherDiagnosis1'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis1')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode3"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA3Model"
                            :Input="changePOA3"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ3'"
                            v-bind:TypeProp="'text'"
                            v-model="adj3Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment4Model"
                            :Input="changeIPFComoAdjustment4"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment4Model"
                            :Input="changeIPFDrgAdjustment4"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis2Code"
                            v-bind:ModelDescription="otherDiagnosis2Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis2')"
                            v-bind:RefCode="'OtherDiagnosis2'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis2')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode4"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA4Model"
                            :Input="changePOA4"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ4'"
                            v-bind:TypeProp="'text'"
                            v-model="adj4Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment5Model"
                            :Input="changeIPFComoAdjustment5"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment5Model"
                            :Input="changeIPFDrgAdjustment5"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis3Code"
                            v-bind:ModelDescription="otherDiagnosis3Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis3')"
                            v-bind:RefCode="'OtherDiagnosis3'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis3')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode5"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA5Model"
                            :Input="changePOA5"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ5'"
                            v-bind:TypeProp="'text'"
                            v-model="adj5Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment6Model"
                            :Input="changeIPFComoAdjustment6"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment6Model"
                            :Input="changeIPFDrgAdjustment6"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis4Code"
                            v-bind:ModelDescription="otherDiagnosis4Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis4')"
                            v-bind:RefCode="'OtherDiagnosis4'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis4')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode6"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA6Model"
                            :Input="changePOA6"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ6'"
                            v-bind:TypeProp="'text'"
                            v-model="adj6Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment7Model"
                            :Input="changeIPFComoAdjustment7"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment7Model"
                            :Input="changeIPFDrgAdjustment7"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis5Code"
                            v-bind:ModelDescription="otherDiagnosis5Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis5')"
                            v-bind:RefCode="'OtherDiagnosis5'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis5')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode7"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA7Model"
                            :Input="changePOA7"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ7'"
                            v-bind:TypeProp="'text'"
                            v-model="adj7Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment8Model"
                            :Input="changeIPFComoAdjustment8"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment8Model"
                            :Input="changeIPFDrgAdjustment8"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis6Code"
                            v-bind:ModelDescription="otherDiagnosis6Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis6')"
                            v-bind:RefCode="'OtherDiagnosis6'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis6')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode8"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA8Model"
                            :Input="changePOA8"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ8'"
                            v-bind:TypeProp="'text'"
                            v-model="adj8Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
            </div>
            <div class="tab-pane fade" id="diag9_16" role="tabpanel">
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment9Model"
                            :Input="changeIPFComoAdjustment9"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment9Model"
                            :Input="changeIPFDrgAdjustment9"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis7Code"
                            v-bind:ModelDescription="otherDiagnosis7Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis7')"
                            v-bind:RefCode="'OtherDiagnosis7'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis7')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode9"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA9Model"
                            :Input="changePOA9"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ9'"
                            v-bind:TypeProp="'text'"
                            v-model="adj9Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment10Model"
                            :Input="changeIPFComoAdjustment10"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment10Model"
                            :Input="changeIPFDrgAdjustment10"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis8Code"
                            v-bind:ModelDescription="otherDiagnosis8Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis8')"
                            v-bind:RefCode="'OtherDiagnosis8'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis8')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode10"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA10Model"
                            :Input="changePOA10"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ10'"
                            v-bind:TypeProp="'text'"
                            v-model="adj10Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment11Model"
                            :Input="changeIPFComoAdjustment11"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment11Model"
                            :Input="changeIPFDrgAdjustment11"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis9Code"
                            v-bind:ModelDescription="otherDiagnosis9Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis9')"
                            v-bind:RefCode="'OtherDiagnosis9'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis9')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode11"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA11Model"
                            :Input="changePOA11"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ11'"
                            v-bind:TypeProp="'text'"
                            v-model="adj11Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment12Model"
                            :Input="changeIPFComoAdjustment12"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment12Model"
                            :Input="changeIPFDrgAdjustment12"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis10Code"
                            v-bind:ModelDescription="otherDiagnosis10Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis10')"
                            v-bind:RefCode="'OtherDiagnosis10'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis10')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode12"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA12Model"
                            :Input="changePOA12"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ12'"
                            v-bind:TypeProp="'text'"
                            v-model="adj12Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment13Model"
                            :Input="changeIPFComoAdjustment13"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment13Model"
                            :Input="changeIPFDrgAdjustment13"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis11Code"
                            v-bind:ModelDescription="otherDiagnosis11Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis11')"
                            v-bind:RefCode="'OtherDiagnosis11'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis11')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode13"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA13Model"
                            :Input="changePOA13"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ13'"
                            v-bind:TypeProp="'text'"
                            v-model="adj13Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment14Model"
                            :Input="changeIPFComoAdjustment14"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment14Model"
                            :Input="changeIPFDrgAdjustment14"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis12Code"
                            v-bind:ModelDescription="otherDiagnosis12Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis12')"
                            v-bind:RefCode="'OtherDiagnosis12'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis12')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode14"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA14Model"
                            :Input="changePOA14"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ14'"
                            v-bind:TypeProp="'text'"
                            v-model="adj14Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment15Model"
                            :Input="changeIPFComoAdjustment15"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment15Model"
                            :Input="changeIPFDrgAdjustment15"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis13Code"
                            v-bind:ModelDescription="otherDiagnosis13Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis13')"
                            v-bind:RefCode="'OtherDiagnosis13'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis13')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode15"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA15Model"
                            :Input="changePOA15"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ15'"
                            v-bind:TypeProp="'text'"
                            v-model="adj15Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment16Model"
                            :Input="changeIPFComoAdjustment16"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment16Model"
                            :Input="changeIPFDrgAdjustment16"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis14Code"
                            v-bind:ModelDescription="otherDiagnosis14Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis14')"
                            v-bind:RefCode="'OtherDiagnosis14'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis14')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode16"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA16Model"
                            :Input="changePOA16"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ16'"
                            v-bind:TypeProp="'text'"
                            v-model="adj16Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
            </div>
            <div class="tab-pane fade" id="diag17_25" role="tabpanel">
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment17Model"
                            :Input="changeIPFComoAdjustment17"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment17Model"
                            :Input="changeIPFDrgAdjustment17"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis15Code"
                            v-bind:ModelDescription="otherDiagnosis15Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis15')"
                            v-bind:RefCode="'OtherDiagnosis15'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis15')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode17"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA17Model"
                            :Input="changePOA17"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ17'"
                            v-bind:TypeProp="'text'"
                            v-model="adj17Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment18Model"
                            :Input="changeIPFComoAdjustment18"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment18Model"
                            :Input="changeIPFDrgAdjustment18"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis16Code"
                            v-bind:ModelDescription="otherDiagnosis16Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis16')"
                            v-bind:RefCode="'OtherDiagnosis16'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis16')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode18"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA18Model"
                            :Input="changePOA18"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ18'"
                            v-bind:TypeProp="'text'"
                            v-model="adj18Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment19Model"
                            :Input="changeIPFComoAdjustment19"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment19Model"
                            :Input="changeIPFDrgAdjustment19"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis17Code"
                            v-bind:ModelDescription="otherDiagnosis17Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis17')"
                            v-bind:RefCode="'OtherDiagnosis17'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis17')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode19"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA19Model"
                            :Input="changePOA19"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ19'"
                            v-bind:TypeProp="'text'"
                            v-model="adj19Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment20Model"
                            :Input="changeIPFComoAdjustment20"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment20Model"
                            :Input="changeIPFDrgAdjustment20"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis18Code"
                            v-bind:ModelDescription="otherDiagnosis18Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis18')"
                            v-bind:RefCode="'OtherDiagnosis18'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis18')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode20"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA20Model"
                            :Input="changePOA20"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ20'"
                            v-bind:TypeProp="'text'"
                            v-model="adj20Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment21Model"
                            :Input="changeIPFComoAdjustment21"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment21Model"
                            :Input="changeIPFDrgAdjustment21"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis19Code"
                            v-bind:ModelDescription="otherDiagnosis19Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis19')"
                            v-bind:RefCode="'OtherDiagnosis19'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis19')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode21"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA21Model"
                            :Input="changePOA21"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ21'"
                            v-bind:TypeProp="'text'"
                            v-model="adj21Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment22Model"
                            :Input="changeIPFComoAdjustment22"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment22Model"
                            :Input="changeIPFDrgAdjustment22"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis20Code"
                            v-bind:ModelDescription="otherDiagnosis20Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis20')"
                            v-bind:RefCode="'OtherDiagnosis20'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis20')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode22"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA22Model"
                            :Input="changePOA22"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ22'"
                            v-bind:TypeProp="'text'"
                            v-model="adj22Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment23Model"
                            :Input="changeIPFComoAdjustment23"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment23Model"
                            :Input="changeIPFDrgAdjustment23"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis21Code"
                            v-bind:ModelDescription="otherDiagnosis21Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis21')"
                            v-bind:RefCode="'OtherDiagnosis21'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis21')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode23"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA23Model"
                            :Input="changePOA23"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ23'"
                            v-bind:TypeProp="'text'"
                            v-model="adj23Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment24Model"
                            :Input="changeIPFComoAdjustment24"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment24Model"
                            :Input="changeIPFDrgAdjustment24"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis22Code"
                            v-bind:ModelDescription="otherDiagnosis22Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis22')"
                            v-bind:RefCode="'OtherDiagnosis22'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis22')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode24"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA24Model"
                            :Input="changePOA24"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ24'"
                            v-bind:TypeProp="'text'"
                            v-model="adj24Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.ComobidityCategory')"
                            v-bind:Options="IPFComoAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="true"
                            v-bind:Model="IPFComoAdjustment25Model"
                            :Input="changeIPFComoAdjustment25"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.DiagnosisRelatedGroup')"
                            v-bind:Options="IPFDrgAdjustmentOptions"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="IPFDrgAdjustment25Model"
                            :Input="changeIPFDrgAdjustment25"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdLookup
                            v-bind:ModelCode="otherDiagnosis23Code"
                            v-bind:ModelDescription="otherDiagnosis23Description"
                            v-bind:Label="$t('ChargeSheet.OtherDiagnosis23')"
                            v-bind:RefCode="'OtherDiagnosis23'"
                            v-bind:AuxFields="this.primaryAuxFields"
                            v-bind:Api="`ChargeSheet/OtherDiagnosis?Version=${this.version}`"
                            v-bind:FieldCode="'code'"
                            v-bind:FieldDescription="'dName'"
                            :SearchTitle="$t('ChargeSheet.OtherDiagnosis23')"
                            :GetValues="onCodeConditionOk"
                            :SearchFieldCode="'code'"
                            v-bind:Fields="BaseFields"
                            :searchWArray="true"
                            :searchCode="this.ComoCode25"
                        />
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdSelect
                            v-bind:Label="$t('ChargeSheet.POA')"
                            v-bind:Options="POAOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="true"
                            v-bind:Multiple="false"
                            v-bind:ModelArray="POA25Model"
                            :Input="changePOA25"/>
                    </b-col>
                    <b-col lg="1" md="1" sm="12">
                        <MdEdit
                            v-bind:Label="$t('ChargeSheet.ADJ')"
                            v-bind:Name="'ADJ25'"
                            v-bind:TypeProp="'text'"
                            v-model="adj25Model"
                            v-bind:isReadOnly="true"/>
                    </b-col>
                </b-row>
            </div>
        </div>
    </MdTabList>

    <b-row>
        <b-col lg="2" md="2" sm="12">
            <MdEdit
                v-bind:Label="$t('ChargeSheet.LOS')"
                v-bind:Name="'LOS'"
                v-bind:TypeProp="'text'"
                v-model="LOSModel"
                v-bind:isReadOnly="true"/>
        </b-col>
        <b-col lg="2" md="2" sm="12">
            <MdEdit
                v-bind:Label="$t('ChargeSheet.ECT')"
                v-bind:Name="'ECT'"
                v-bind:TypeProp="'text'"
                v-model="ECTModel"/>
        </b-col>
        <b-col lg="2" md="2" sm="12">
            <MdEdit
                v-bind:Label="$t('Shared.Age')"
                v-bind:Name="'Age'"
                v-bind:TypeProp="'text'"
                v-model="AgeModel"/>
        </b-col>
        <b-col lg="2" md="2" sm="12">
            <MdEdit
                v-bind:Label="$t('ChargeSheet.AgeADJ')"
                v-bind:Name="'AgeADJ'"
                v-bind:TypeProp="'text'"
                v-model="AgeADJModel"
                v-bind:isReadOnly="true"/>
        </b-col>
        <b-col lg="2" md="2" sm="12">
            <MdEdit
                v-bind:Label="$t('ChargeSheet.CoveredCharges')"
                v-bind:Name="'CoveredCharges'"
                v-bind:TypeProp="'text'"
                v-model="CoveredChargesModel"/>
        </b-col>
        <b-col lg="2" md="2" sm="12">
            <MdLookup
                v-bind:ModelCode="doctorCode"
                v-bind:ModelDescription="doctorDesc"
                v-bind:Label="$tc('MdPatientRegistrationInfo.DoctorName')"
                v-bind:RefCode="'Doctor'"
                v-bind:Fields="DoctorsFields"
                v-bind:Api="'Doctors'"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"
                :SearchTitle="$tc('MdPatientRegistrationInfo.DoctorName')"
                :GetValues="onCodeConditionOk"
                :SearchFieldCode="'code'"
            />
        </b-col>
    </b-row>
  <div>
    <div class="table-notes-title">
        <div class="text-truncate t-header">{{$t('TestOrderResult.Result')}}</div>
        <div class="btn-group btn-group-sm float-sm-right" role="group" aria-label="Table options">
            <template>
                <b-tooltip
                    :target="'add-action-button'"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                {{ $t('ChargeSheet.Compute') }}
                </b-tooltip>
                <b-button
                    id="add-action-button"
                    class="table-title-btn"
                >
                    {{ $t('ChargeSheet.Compute') }}
                </b-button>
            </template>

            <template>
                <b-tooltip
                    target="edit-selected-button"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                    {{ $t('MdEditTableCN.Clear') }}
                </b-tooltip>
                <b-button
                    id="edit-selected-button"
                    class="table-title-btn"
                >
                    {{ $t('MdEditTableCN.Clear') }}
                </b-button>
            </template>

            <template>
                <b-tooltip
                    :target="'delete-action-button'"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                    {{ $t('schedule_sample.Print') }}
                </b-tooltip>
                <b-button
                    id="delete-action-button"
                    class="table-title-btn"
                >
                    {{ $t('schedule_sample.Print') }}
                </b-button>
            </template>

            <template>
                <b-tooltip
                    :target="'delete-action-button'"
                    placement="top"
                    :delay="{ show: 1500, hide: 50 }"
                >
                    Save to file
                </b-tooltip>
                <b-button
                    id="delete-action-button"
                    class="table-title-btn"
                >
                    Save to file
                </b-button>
            </template>
        </div>
    </div>
    <b-row>
       <b-col lg="12" md="12" sm="12">
            <MdMemo
                v-bind:Name="'textarea_result'"
                v-bind:Rows="'8'"
                v-bind:MaxRows="'8'"
                v-bind:MaxLength="'500'"
                v-model="ResultModel"/>
        </b-col>
    </b-row>
 </div>
    <div class="space-actions"></div>
         <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:Name="'btnpatientlist'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="goBack"/>
        <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">
          <b-dropdown-item-button v-on:click="getReadICD10Codes">
            {{ $t('ChargeSheet.GETPREVDIAG') }}
          </b-dropdown-item-button>

          <b-dropdown-item-button v-on:click="updatePatientDiagnosis">
            {{ $t('ChargeSheet.UpdPatient') }}
          </b-dropdown-item-button>

          <b-dropdown-item-button v-on:click="UpdateAllClaim">
            {{ $t('ChargeSheet.UpdAllClaims') }}
          </b-dropdown-item-button>

          <b-dropdown-item-button v-on:click="AddICD10">
            {{ $t('Shared.Save') }}
          </b-dropdown-item-button>
        </b-dropdown>
    </div>
  </div>
</template>

<script>
    import ChargeSheetService from '@/services/chargesheet.service'
    import ShowMessage from '@/components/messages/ShowMessage.js';
    import IPFcomoadjustmentsService from '@/services/ipfcomoadjustment.service'
    import IPFDrgAdjustmentsService from '@/services/ipfdrgadjustment.service'
    import EnumService from '@/services/enum.service'
    import DBFunctions from '@/common/DBFunctions.js';
    import Utils from "@/common/utils";

    export default {
        mixins: [ShowMessage, DBFunctions],
        name: 'ChargeSheetWork',
        data(){
        return {
            recordId: this.$route.params.recordid,
            patientCode: this.$route.params.id,
            PatientTitle: {
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:'',
                activitytypename:'',
                startdatetime:'',
                ageFormatted:''
            },
            items: [],
            isICD9: false,
            tablist: [
                { title: this.$t('ChargeSheet.DIAGNOSIS1-8'), link: '#diag1_8', active: true},
                { title: this.$t('ChargeSheet.DIAGNOSIS9-16'), link: '#diag9_16'},
                { title: this.$t('ChargeSheet.DIAGNOSIS17-25'), link: '#diag17_25'},
            ],
            verOptions: EnumService.ICDVersion,
            POAOptions: EnumService.POAOptions,
            diagVerModel: {},

            IPFComoAdjustmentOptions: [],
            IPFComoAdjustment1Model: null,
            IPFComoAdjustment2Model: null,
            IPFComoAdjustment3Model: null,
            IPFComoAdjustment4Model: null,
            IPFComoAdjustment5Model: null,
            IPFComoAdjustment6Model: null,
            IPFComoAdjustment7Model: null,
            IPFComoAdjustment8Model: null,
            IPFComoAdjustment9Model: null,
            IPFComoAdjustment10Model: null,
            IPFComoAdjustment11Model: null,
            IPFComoAdjustment12Model: null,
            IPFComoAdjustment13Model: null,
            IPFComoAdjustment14Model: null,
            IPFComoAdjustment15Model: null,
            IPFComoAdjustment16Model: null,
            IPFComoAdjustment17Model: null,
            IPFComoAdjustment18Model: null,
            IPFComoAdjustment19Model: null,
            IPFComoAdjustment20Model: null,
            IPFComoAdjustment21Model: null,
            IPFComoAdjustment22Model: null,
            IPFComoAdjustment23Model: null,
            IPFComoAdjustment24Model: null,
            IPFComoAdjustment25Model: null,

            IPFDrgAdjustmentOptions: [],
            IPFDrgAdjustment1Model: null,
            IPFDrgAdjustment2Model: null,
            IPFDrgAdjustment3Model: null,
            IPFDrgAdjustment4Model: null,
            IPFDrgAdjustment5Model: null,
            IPFDrgAdjustment6Model: null,
            IPFDrgAdjustment7Model: null,
            IPFDrgAdjustment8Model: null,
            IPFDrgAdjustment9Model: null,
            IPFDrgAdjustment10Model: null,
            IPFDrgAdjustment11Model: null,
            IPFDrgAdjustment12Model: null,
            IPFDrgAdjustment13Model: null,
            IPFDrgAdjustment14Model: null,
            IPFDrgAdjustment15Model: null,
            IPFDrgAdjustment16Model: null,
            IPFDrgAdjustment17Model: null,
            IPFDrgAdjustment18Model: null,
            IPFDrgAdjustment19Model: null,
            IPFDrgAdjustment20Model: null,
            IPFDrgAdjustment21Model: null,
            IPFDrgAdjustment22Model: null,
            IPFDrgAdjustment23Model: null,
            IPFDrgAdjustment24Model: null,
            IPFDrgAdjustment25Model: null,

            POA1Model: null,
            POA2Model: null,
            POA3Model: null,
            POA4Model: null,
            POA5Model: null,
            POA6Model: null,
            POA7Model: null,
            POA8Model: null,
            POA9Model: null,
            POA10Model: null,
            POA11Model: null,
            POA12Model: null,
            POA13Model: null,
            POA14Model: null,
            POA15Model: null,
            POA16Model: null,
            POA17Model: null,
            POA18Model: null,
            POA19Model: null,
            POA20Model: null,
            POA21Model: null,
            POA22Model: null,
            POA23Model: null,
            POA24Model: null,
            POA25Model: null,

            primaryAuxFields:['adjustment'],
            BaseFields:[
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'dName', sortable: true, label: 'Name'},
                { key: 'adjustment', sortable: true, label: 'Adjustment'},
                { key: 'drG_Code', sortable: true, label: 'DRG Code'},
                { key: 'drG_Description', sortable: true, label: 'DRG Description'},


            ],
            admittingCode: null,
            admittingDescription: null,
            primaryCode: null,
            primaryDescription: null,
            otherDiagnosis1Code: null,
            otherDiagnosis1Description: null,
            otherDiagnosis2Code: null,
            otherDiagnosis2Description: null,
            otherDiagnosis3Code: null,
            otherDiagnosis3Description: null,
            otherDiagnosis4Code: null,
            otherDiagnosis4Description: null,
            otherDiagnosis5Code: null,
            otherDiagnosis5Description: null,
            otherDiagnosis6Code: null,
            otherDiagnosis6Description: null,
            otherDiagnosis7Code: null,
            otherDiagnosis7Description: null,
            otherDiagnosis8Code: null,
            otherDiagnosis8Description: null,
            otherDiagnosis9Code: null,
            otherDiagnosis9Description: null,
            otherDiagnosis10Code: null,
            otherDiagnosis10Description: null,
            otherDiagnosis11Code: null,
            otherDiagnosis11Description: null,
            otherDiagnosis12Code: null,
            otherDiagnosis12Description: null,
            otherDiagnosis13Code: null,
            otherDiagnosis13Description: null,
            otherDiagnosis14Code: null,
            otherDiagnosis14Description: null,
            otherDiagnosis15Code: null,
            otherDiagnosis15Description: null,
            otherDiagnosis16Code: null,
            otherDiagnosis16Description: null,
            otherDiagnosis17Code: null,
            otherDiagnosis17Description: null,
            otherDiagnosis18Code: null,
            otherDiagnosis18Description: null,
            otherDiagnosis19Code: null,
            otherDiagnosis19Description: null,
            otherDiagnosis20Code: null,
            otherDiagnosis20Description: null,
            otherDiagnosis21Code: null,
            otherDiagnosis21Description: null,
            otherDiagnosis22Code: null,
            otherDiagnosis22Description: null,
            otherDiagnosis23Code: null,
            otherDiagnosis23Description: null,

            version: 10,
            ComoCode1: [],
            ComoCode2: [],
            ComoCode3: [],
            ComoCode4: [],
            ComoCode5: [],
            ComoCode6: [],
            ComoCode7: [],
            ComoCode8: [],
            ComoCode9: [],
            ComoCode10: [],
            ComoCode11: [],
            ComoCode12: [],
            ComoCode13: [],
            ComoCode14: [],
            ComoCode15: [],
            ComoCode16: [],
            ComoCode17: [],
            ComoCode18: [],
            ComoCode19: [],
            ComoCode20: [],
            ComoCode21: [],
            ComoCode22: [],
            ComoCode23: [],
            ComoCode24: [],
            ComoCode25: [],

            adj1Model: null,
            adj2Model: null,
            adj3Model: null,
            adj4Model: null,
            adj5Model: null,
            adj6Model: null,
            adj7Model: null,
            adj8Model: null,
            adj9Model: null,
            adj10Model: null,
            adj11Model: null,
            adj12Model: null,
            adj13Model: null,
            adj14Model: null,
            adj15Model: null,
            adj16Model: null,
            adj17Model: null,
            adj18Model: null,
            adj19Model: null,
            adj20Model: null,
            adj21Model: null,
            adj22Model: null,
            adj23Model: null,
            adj24Model: null,
            adj25Model: null,
            ReadICD10Codes: [],
            ICD10: {
                DoctorCode: null,
                DiagCode1: null,
                DiagCode2: null,
                DiagCode3: null,
                DiagCode4: null,
                DiagCode5: null,
                DiagCode6: null,
                DiagCode7: null,
                DiagCode8: null,
                DiagCode9: null,
                DiagCode10: null,
                DiagCode11: null,
                DiagCode12: null,
                DiagCode13: null,
                DiagCode14: null,
                DiagCode15: null,
                DiagCode16: null,
                DiagCode17: null,
                DiagCode18: null,
                DiagCode19: null,
                DiagCode20: null,
                DiagCode21: null,
                DiagCode22: null,
                DiagCode23: null,
                DiagCode24: null,
                DiagCode25: null,
                POA1: null,
                POA2: null,
                POA3: null,
                POA4: null,
                POA5: null,
                POA6: null,
                POA7: null,
                POA8: null,
                POA9: null,
                POA10: null,
                POA11: null,
                POA12: null,
                POA13: null,
                POA14: null,
                POA15: null,
                POA16: null,
                POA17: null,
                POA18: null,
                POA19: null,
                POA20: null,
                POA21: null,
                POA22: null,
                POA23: null,
                POA24: null,
                POA25: null,
            },
            patientDiagnosis: {
                DoctorCode: null,
                DiagCode1: null,
                DiagCode2: null,
                DiagCode3: null,
                DiagCode4: null,
                DiagCode5: null,
                DiagCode6: null,
                DiagCode7: null,
                DiagCode8: null,
                DiagCode9: null,
                DiagCode10: null,
                DiagCode11: null,
                DiagCode12: null,
                DiagCode13: null,
                DiagCode14: null,
                DiagCode15: null,
                DiagCode16: null,
                DiagCode17: null,
                DiagCode18: null,
                DiagCode19: null,
                DiagCode20: null,
                DiagCode21: null,
                DiagCode22: null,
                DiagCode23: null,
                DiagCode24: null,
                DiagCode25: null,
            },
            LOSModel: null,
            ECTModel: null,
            AgeModel: null,
            AgeADJModel: null,
            CoveredChargesModel: null,
            DoctorsFields:[
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'name', sortable: true, label: this.$t('Shared.Description') },
            ],
            doctorCode: null,
            doctorDesc: null,
            AddtInfo: {
               los: null,
               ageAdj: null,
               coveredCharges: null
            },
            ResultModel:null,

        };
      },
      methods: {
        populatePatientDiagnosis() {
            this.patientDiagnosis.DoctorCode = this.doctorCode
            this.patientDiagnosis.DiagCode1 = this.admittingCode
            this.patientDiagnosis.DiagCode2 = this.primaryCode
            this.patientDiagnosis.DiagCode3 = this.otherDiagnosis1Code
            this.patientDiagnosis.DiagCode4 = this.otherDiagnosis2Code
            this.patientDiagnosis.DiagCode5 = this.otherDiagnosis3Code
            this.patientDiagnosis.DiagCode6 = this.otherDiagnosis4Code
            this.patientDiagnosis.DiagCode7 = this.otherDiagnosis5Code
            this.patientDiagnosis.DiagCode8 = this.otherDiagnosis6Code
            this.patientDiagnosis.DiagCode9 = this.otherDiagnosis7Code
            this.patientDiagnosis.DiagCode10 = this.otherDiagnosis8Code
            this.patientDiagnosis.DiagCode11 = this.otherDiagnosis9Code
            this.patientDiagnosis.DiagCode12 = this.otherDiagnosis10Code
            this.patientDiagnosis.DiagCode13 = this.otherDiagnosis11Code
            this.patientDiagnosis.DiagCode14 = this.otherDiagnosis12Code
            this.patientDiagnosis.DiagCode15 = this.otherDiagnosis13Code
            this.patientDiagnosis.DiagCode16 = this.otherDiagnosis14Code
            this.patientDiagnosis.DiagCode17 = this.otherDiagnosis15Code
            this.patientDiagnosis.DiagCode18 = this.otherDiagnosis16Code
            this.patientDiagnosis.DiagCode19 = this.otherDiagnosis17Code
            this.patientDiagnosis.DiagCode20 = this.otherDiagnosis18Code
            this.patientDiagnosis.DiagCode21 = this.otherDiagnosis19Code
            this.patientDiagnosis.DiagCode22 = this.otherDiagnosis20Code
            this.patientDiagnosis.DiagCode23 = this.otherDiagnosis21Code
            this.patientDiagnosis.DiagCode24 = this.otherDiagnosis22Code
            this.patientDiagnosis.DiagCode25 = this.otherDiagnosis23Code
        },

        async updatePatientDiagnosis() {
            this.populatePatientDiagnosis()

            await ChargeSheetService.UpdateDiagnosis(this.patientCode,this.patientDiagnosis)
                .then((response) => {
                    if(response.status == '200'){
                        this.showMessage(this.$t('ChargeSheet.WorkSheet'),this.$t('ChargeSheet.MsgUpdateDiag'));
                      }
                  }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async UpdateAllClaim() {
            let params = {
                diagcode: this.admittingCode,
                datefrom: this.items[0].minServiceDate,
                dateto: this.items[0].maxServiceDate,
                patientcode: this.patientCode
            }

            await ChargeSheetService.UpdateAllClaim(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.showMessage(this.$t('ChargeSheet.WorkSheet'),this.$t('ChargeSheet.MsgUpdateAllClaim'));
                      }
                  }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        onCodeConditionOk(result) {
            var type = result.FieldName;
                switch (type) {
                    case "Admitting":
                        this.admittingCode = result.code;
                        this.admittingDescription = result.description;
                        this.adj1Model = result.AuxFields[0]
                        this.ICD10.DiagCode1 = result.code;
                    break;
                    case "Primary":
                        this.primaryCode = result.code;
                        this.primaryDescription = result.description;
                        this.adj2Model = result.AuxFields[0]
                        this.ICD10.DiagCode2 = result.code;
                    break;
                    case "OtherDiagnosis1":
                        this.otherDiagnosis1Code = result.code;
                        this.otherDiagnosis1Description = result.description;
                        this.adj3Model = result.AuxFields[0]
                        this.ICD10.DiagCode3 = result.code;
                    break;
                    case "OtherDiagnosis2":
                        this.otherDiagnosis2Code = result.code;
                        this.otherDiagnosis2Description = result.description;
                        this.adj4Model = result.AuxFields[0]
                        this.ICD10.DiagCode4 = result.code;
                    break;
                    case "OtherDiagnosis3":
                        this.otherDiagnosis3Code = result.code;
                        this.otherDiagnosis3Description = result.description;
                        this.adj5Model = result.AuxFields[0]
                        this.ICD10.DiagCode5 = result.code;
                    break;
                    case "OtherDiagnosis4":
                        this.otherDiagnosis4Code = result.code;
                        this.otherDiagnosis4Description = result.description;
                        this.adj6Model = result.AuxFields[0]
                        this.ICD10.DiagCode6 = result.code;
                    break;
                    case "OtherDiagnosis5":
                        this.otherDiagnosis5Code = result.code;
                        this.otherDiagnosis5Description = result.description;
                        this.adj7Model = result.AuxFields[0]
                        this.ICD10.DiagCode7 = result.code;
                    break;
                    case "OtherDiagnosis6":
                        this.otherDiagnosis6Code = result.code;
                        this.otherDiagnosis6Description = result.description;
                        this.adj8Model = result.AuxFields[0]
                        this.ICD10.DiagCode8 = result.code;
                    break;
                    case "OtherDiagnosis7":
                        this.otherDiagnosis7Code = result.code;
                        this.otherDiagnosis7Description = result.description;
                        this.adj9Model = result.AuxFields[0]
                        this.ICD10.DiagCode9 = result.code;
                    break;
                    case "OtherDiagnosis8":
                        this.otherDiagnosis8Code = result.code;
                        this.otherDiagnosis8Description = result.description;
                        this.adj10Model = result.AuxFields[0]
                        this.ICD10.DiagCode10 = result.code;
                    break;
                    case "OtherDiagnosis9":
                        this.otherDiagnosis9Code = result.code;
                        this.otherDiagnosis9Description = result.description;
                        this.adj11Model = result.AuxFields[0]
                        this.ICD10.DiagCode11 = result.code;
                    break;
                    case "OtherDiagnosis10":
                        this.otherDiagnosis10Code = result.code;
                        this.otherDiagnosis10Description = result.description;
                        this.adj12Model = result.AuxFields[0]
                        this.ICD10.DiagCode12 = result.code;
                    break;
                    case "OtherDiagnosis11":
                        this.otherDiagnosis11Code = result.code;
                        this.otherDiagnosis11Description = result.description;
                        this.adj13Model = result.AuxFields[0]
                        this.ICD10.DiagCode13 = result.code;
                    break;
                    case "OtherDiagnosis12":
                        this.otherDiagnosis12Code = result.code;
                        this.otherDiagnosis12Description = result.description;
                        this.adj14Model = result.AuxFields[0]
                        this.ICD10.DiagCode14 = result.code;
                    break;
                    case "OtherDiagnosis13":
                        this.otherDiagnosis13Code = result.code;
                        this.otherDiagnosis13Description = result.description;
                        this.adj15Model = result.AuxFields[0]
                        this.ICD10.DiagCode15 = result.code;
                    break;
                    case "OtherDiagnosis14":
                        this.otherDiagnosis14Code = result.code;
                        this.otherDiagnosis14Description = result.description;
                        this.adj16Model = result.AuxFields[0]
                        this.ICD10.DiagCode16 = result.code;
                    break;
                    case "OtherDiagnosis15":
                        this.otherDiagnosis15Code = result.code;
                        this.otherDiagnosis15Description = result.description;
                        this.adj17Model = result.AuxFields[0]
                        this.ICD10.DiagCode17 = result.code;
                    break;
                    case "OtherDiagnosis16":
                        this.otherDiagnosis16Code = result.code;
                        this.otherDiagnosis16Description = result.description;
                        this.adj18Model = result.AuxFields[0]
                        this.ICD10.DiagCode18 = result.code;
                    break;
                    case "OtherDiagnosis17":
                        this.otherDiagnosis17Code = result.code;
                        this.otherDiagnosis17Description = result.description;
                        this.adj19Model = result.AuxFields[0]
                        this.ICD10.DiagCode19 = result.code;
                    break;
                    case "OtherDiagnosis18":
                        this.otherDiagnosis18Code = result.code;
                        this.otherDiagnosis18Description = result.description;
                        this.adj20Model = result.AuxFields[0]
                        this.ICD10.DiagCode20 = result.code;
                    break;
                    case "OtherDiagnosis19":
                        this.otherDiagnosis19Code = result.code;
                        this.otherDiagnosis19Description = result.description;
                        this.adj21Model = result.AuxFields[0]
                        this.ICD10.DiagCode21 = result.code;
                    break;
                    case "OtherDiagnosis20":
                        this.otherDiagnosis20Code = result.code;
                        this.otherDiagnosis20Description = result.description;
                        this.adj22Model = result.AuxFields[0]
                        this.ICD10.DiagCode22 = result.code;
                    break;
                    case "OtherDiagnosis21":
                        this.otherDiagnosis21Code = result.code;
                        this.otherDiagnosis21Description = result.description;
                        this.adj23Model = result.AuxFields[0]
                        this.ICD10.DiagCode23 = result.code;
                    break;
                    case "OtherDiagnosis22":
                        this.otherDiagnosis22Code = result.code;
                        this.otherDiagnosis22Description = result.description;
                        this.adj24Model = result.AuxFields[0]
                        this.ICD10.DiagCode24 = result.code;
                    break;
                    case "Doctor":
                        this.doctorCode = result.code;
                        this.doctorDesc = result.description;
                        this.ICD10.DoctorCode = result.code;
                    break;
                    default:
                        this.otherDiagnosis23Code = result.code;
                        this.otherDiagnosis23Description = result.description;
                        this.adj25Model = result.AuxFields[0]
                        this.ICD10.DiagCode25 = result.code;
            }
        },

        changePOA1(item) {
            this.POA1Model = item
            this.ICD10.POA1 = item && item.value ? item.value : null
        },
        changePOA2(item) {
            this.POA2Model = item
            this.ICD10.POA2 = item && item.value ? item.value : null
        },
        changePOA3(item) {
            this.POA3Model = item
            this.ICD10.POA3 = item && item.value ? item.value : null
        },
        changePOA4(item) {
            this.POA4Model = item
            this.ICD10.POA4 = item && item.value ? item.value : null
        },
        changePOA5(item) {
            this.POA5Model = item
            this.ICD10.POA5 = item && item.value ? item.value : null
        },
        changePOA6(item) {
            this.POA6Model = item
            this.ICD10.POA6 = item && item.value ? item.value : null
        },
        changePOA7(item) {
            this.POA7Model = item
            this.ICD10.POA7 = item && item.value ? item.value : null
        },
        changePOA8(item) {
            this.POA8Model = item
            this.ICD10.POA8 = item && item.value ? item.value : null
        },
        changePOA9(item) {
            this.POA9Model = item
            this.ICD10.POA9 = item && item.value ? item.value : null
        },
        changePOA10(item) {
            this.POA10Model = item
            this.ICD10.POA10 = item && item.value ? item.value : null
        },
        changePOA11(item) {
            this.POA11Model = item
            this.ICD10.POA11 = item && item.value ? item.value : null
        },
        changePOA12(item) {
            this.POA12Model = item
            this.ICD10.POA12 = item && item.value ? item.value : null
        },
        changePOA13(item) {
            this.POA13Model = item
            this.ICD10.POA13 = item && item.value ? item.value : null
        },
        changePOA14(item) {
            this.POA14Model = item
            this.ICD10.POA14 = item && item.value ? item.value : null
        },
        changePOA15(item) {
            this.POA15Model = item
            this.ICD10.POA15 = item && item.value ? item.value : null
        },
        changePOA16(item) {
            this.POA16Model = item
            this.ICD10.POA16 = item && item.value ? item.value : null
        },
        changePOA17(item) {
            this.POA17Model = item
            this.ICD10.POA17 = item && item.value ? item.value : null
        },
        changePOA18(item) {
            this.POA18Model = item
            this.ICD10.POA18 = item && item.value ? item.value : null
        },
        changePOA19(item) {
            this.POA19Model = item
            this.ICD10.POA19 = item && item.value ? item.value : null
        },
        changePOA20(item) {
            this.POA20Model = item
            this.ICD10.POA20 = item && item.value ? item.value : null
        },
        changePOA21(item) {
            this.POA21Model = item
            this.ICD10.POA21 = item && item.value ? item.value : null
        },
        changePOA22(item) {
            this.POA22Model = item
            this.ICD10.POA22 = item && item.value ? item.value : null
        },
        changePOA23(item) {
            this.POA23Model = item
            this.ICD10.POA23 = item && item.value ? item.value : null
        },
        changePOA24(item) {
            this.POA24Model = item
            this.ICD10.POA24 = item && item.value ? item.value : null
        },
        changePOA25(item) {
            this.POA25Model = item
            this.ICD10.POA25 = item && item.value ? item.value : null
        },

        getCodes(item) {
            let codes = []
            item.forEach(el => {
              codes.push(el.code)
            });
            return codes
        },

        changeIPFComoAdjustment1(item) {
            this.IPFComoAdjustment1Model = item
            this.ComoCode1 = this.getCodes(item)
        },
        changeIPFComoAdjustment2(item) {
            this.IPFComoAdjustment2Model = item
            this.ComoCode2 = this.getCodes(item)
        },
        changeIPFComoAdjustment3(item) {
            this.IPFComoAdjustment3Model = item
            this.ComoCode3 = this.getCodes(item)
        },
        changeIPFComoAdjustment4(item) {
            this.IPFComoAdjustment4Model = item
            this.ComoCode4 = this.getCodes(item)
        },
        changeIPFComoAdjustment5(item) {
            this.IPFComoAdjustment5Model = item
            this.ComoCode5 = this.getCodes(item)
        },
        changeIPFComoAdjustment6(item) {
            this.IPFComoAdjustment6Model = item
            this.ComoCode6 = this.getCodes(item)
        },
        changeIPFComoAdjustment7(item) {
            this.IPFComoAdjustment7Model = item
            this.ComoCode7 = this.getCodes(item)
        },
        changeIPFComoAdjustment8(item) {
            this.IPFComoAdjustment8Model = item
            this.ComoCode8 = this.getCodes(item)
        },
        changeIPFComoAdjustment9(item) {
            this.IPFComoAdjustment9Model = item
            this.ComoCode9 = this.getCodes(item)
        },
        changeIPFComoAdjustment10(item) {
            this.IPFComoAdjustment10Model = item
            this.ComoCode10 = this.getCodes(item)
        },
        changeIPFComoAdjustment11(item) {
            this.IPFComoAdjustment11Model = item
            this.ComoCode11 = this.getCodes(item)
        },
        changeIPFComoAdjustment12(item) {
            this.IPFComoAdjustment12Model = item
            this.ComoCode12 = this.getCodes(item)
        },
        changeIPFComoAdjustment13(item) {
            this.IPFComoAdjustment13Model = item
            this.ComoCode13 = this.getCodes(item)
        },
        changeIPFComoAdjustment14(item) {
            this.IPFComoAdjustment14Model = item
            this.ComoCode14 = this.getCodes(item)
        },
        changeIPFComoAdjustment15(item) {
            this.IPFComoAdjustment15Model = item
            this.ComoCode15 = this.getCodes(item)
        },
        changeIPFComoAdjustment16(item) {
            this.IPFComoAdjustment16Model = item
            this.ComoCode16 = this.getCodes(item)
        },
        changeIPFComoAdjustment17(item) {
            this.IPFComoAdjustment17Model = item
            this.ComoCode17 = this.getCodes(item)
        },
        changeIPFComoAdjustment18(item) {
            this.IPFComoAdjustment18Model = item
            this.ComoCode18 = this.getCodes(item)
        },
        changeIPFComoAdjustment19(item) {
            this.IPFComoAdjustment19Model = item
            this.ComoCode19 = this.getCodes(item)
        },
        changeIPFComoAdjustment20(item) {
            this.IPFComoAdjustment20Model = item
            this.ComoCode20 = this.getCodes(item)
        },
        changeIPFComoAdjustment21(item) {
            this.IPFComoAdjustment21Model = item
            this.ComoCode21 = this.getCodes(item)
        },
        changeIPFComoAdjustment22(item) {
            this.IPFComoAdjustment22Model = item
            this.ComoCode22 = this.getCodes(item)
        },
        changeIPFComoAdjustment23(item) {
            this.IPFComoAdjustment23Model = item
            this.ComoCode23 = this.getCodes(item)
        },
        changeIPFComoAdjustment24(item) {
            this.IPFComoAdjustment24Model = item
            this.ComoCode24 = this.getCodes(item)
        },
        changeIPFComoAdjustment25(item) {
            this.IPFComoAdjustment25Model = item
            this.ComoCode25 = this.getCodes(item)
        },


        changeIPFDrgAdjustment1(item) {
            this.IPFDrgAdjustment1Model = item
        },
        changeIPFDrgAdjustment2(item) {
            this.IPFDrgAdjustment2Model = item
        },
        changeIPFDrgAdjustment3(item) {
            this.IPFDrgAdjustment3Model = item
        },
        changeIPFDrgAdjustment4(item) {
            this.IPFDrgAdjustment4Model = item
        },
        changeIPFDrgAdjustment5(item) {
            this.IPFDrgAdjustment5Model = item
        },
        changeIPFDrgAdjustment6(item) {
            this.IPFDrgAdjustment6Model = item
        },
        changeIPFDrgAdjustment7(item) {
            this.IPFDrgAdjustment7Model = item
        },
        changeIPFDrgAdjustment8(item) {
            this.IPFDrgAdjustment8Model = item
        },
        changeIPFDrgAdjustment9(item) {
            this.IPFDrgAdjustment9Model = item
        },
        changeIPFDrgAdjustment10(item) {
            this.IPFDrgAdjustment10Model = item
        },
        changeIPFDrgAdjustment11(item) {
            this.IPFDrgAdjustment11Model = item
        },
        changeIPFDrgAdjustment12(item) {
            this.IPFDrgAdjustment12Model = item
        },
        changeIPFDrgAdjustment13(item) {
            this.IPFDrgAdjustment13Model = item
        },
        changeIPFDrgAdjustment14(item) {
            this.IPFDrgAdjustment14Model = item
        },
        changeIPFDrgAdjustment15(item) {
            this.IPFDrgAdjustment15Model = item
        },
        changeIPFDrgAdjustment16(item) {
            this.IPFDrgAdjustment16Model = item
        },
        changeIPFDrgAdjustment17(item) {
            this.IPFDrgAdjustment17Model = item
        },
        changeIPFDrgAdjustment18(item) {
            this.IPFDrgAdjustment18Model = item
        },
        changeIPFDrgAdjustment19(item) {
            this.IPFDrgAdjustment19Model = item
        },
        changeIPFDrgAdjustment20(item) {
            this.IPFDrgAdjustment20Model = item
        },
        changeIPFDrgAdjustment21(item) {
            this.IPFDrgAdjustment21Model = item
        },
        changeIPFDrgAdjustment22(item) {
            this.IPFDrgAdjustment22Model = item
        },
        changeIPFDrgAdjustment23(item) {
            this.IPFDrgAdjustment23Model = item
        },
        changeIPFDrgAdjustment24(item) {
            this.IPFDrgAdjustment24Model = item
        },
        changeIPFDrgAdjustment25(item) {
            this.IPFDrgAdjustment25Model = item
        },

        async GetPatientByCode(){
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
              this.PatientTitle.programName = '';
              this.PatientTitle.admitDate = '';
              this.PatientTitle.dischargeDate = '';

              const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

              if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
              if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
              if (age) this.PatientTitle.age = age;
              if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
              this.AgeModel = age
            }
        },

        goBack() {
            this.$router.push({
              name: "chargesheet"
            });
        },

        async GetChargeSheet() {
            let params = {
                "RecordId":this.recordId,
                "PatientCode": this.patientCode,
            }
            await ChargeSheetService.getAll(params)

                .then((response) => {
                    if(response.status == '200'){
                        this.items = response.data;
                    }
                  }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async AddICD10() {
            await ChargeSheetService.AddICD10(this.patientCode,this.recordId,this.ICD10)
                .then((response) => {
                    if(response.status == '200'){
                        //TODO
                      }
                  }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async GetIPFcomoadjustment() {
            let params = {
                "SearchCriteria":'',
            }
            await IPFcomoadjustmentsService.getAll(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.IPFComoAdjustmentOptions = response.data;
                    }
                  }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async GetIPFDrgAdjustment() {
            let params = {
                "SearchCriteria":'',
            }
            await IPFDrgAdjustmentsService.getAll(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.IPFDrgAdjustmentOptions = response.data;
                    }
                  }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },


        async ChargeSheetIsIDC9(){
            await ChargeSheetService.ChargeSheetIsIDC9(this.patientCode)
                .then((response) => {
                    if(response.status == '200'){
                        this.isICD9 = response.data;
                        if (this.isICD9 == true) {
                            this.diagVerModel= {"value":"ICD9","text":"ICD9"}
                            this.version = 9
                        } else {
                            this.diagVerModel= {"value":"ICD10","text":"ICD10"}
                            this.version = 10
                        }
                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
        },

        changeDiagVer(item) {
            this.diagVerModel = item;
        },

        readPOA(value) {
            return this.POAOptions.find(x => x.value == value)
        },

        async GetChargeSheetReadICD10Codes() {
            let params = {
                "RecordID":this.recordId,
                "PatientCode": this.patientCode,
            }
            await ChargeSheetService.getChargeSheetReadICD10Codes(params)

                .then((response) => {
                    if(response.status == '200'){
                        this.ReadICD10Codes = response.data;
                        this.POA1Model =  this.readPOA(this.ReadICD10Codes[0].poA1)
                        this.POA2Model =  this.readPOA(this.ReadICD10Codes[0].poA2)
                        this.POA3Model =  this.readPOA(this.ReadICD10Codes[0].poA3)
                        this.POA4Model =  this.readPOA(this.ReadICD10Codes[0].poA4)
                        this.POA5Model =  this.readPOA(this.ReadICD10Codes[0].poA5)
                        this.POA6Model =  this.readPOA(this.ReadICD10Codes[0].poA6)
                        this.POA7Model =  this.readPOA(this.ReadICD10Codes[0].poA7)
                        this.POA8Model =  this.readPOA(this.ReadICD10Codes[0].poA8)
                        this.POA9Model =  this.readPOA(this.ReadICD10Codes[0].poA9)
                        this.POA10Model =  this.readPOA(this.ReadICD10Codes[0].poA10)
                        this.POA11Model =  this.readPOA(this.ReadICD10Codes[0].poA11)
                        this.POA12Model =  this.readPOA(this.ReadICD10Codes[0].poA12)
                        this.POA13Model =  this.readPOA(this.ReadICD10Codes[0].poA13)
                        this.POA14Model =  this.readPOA(this.ReadICD10Codes[0].poA14)
                        this.POA15Model =  this.readPOA(this.ReadICD10Codes[0].poA15)
                        this.POA16Model =  this.readPOA(this.ReadICD10Codes[0].poA16)
                        this.POA17Model =  this.readPOA(this.ReadICD10Codes[0].poA17)
                        this.POA18Model =  this.readPOA(this.ReadICD10Codes[0].poA18)
                        this.POA19Model =  this.readPOA(this.ReadICD10Codes[0].poA19)
                        this.POA20Model =  this.readPOA(this.ReadICD10Codes[0].poA20)
                        this.POA21Model =  this.readPOA(this.ReadICD10Codes[0].poA21)
                        this.POA22Model =  this.readPOA(this.ReadICD10Codes[0].poA22)
                        this.POA23Model =  this.readPOA(this.ReadICD10Codes[0].poA23)
                        this.POA24Model =  this.readPOA(this.ReadICD10Codes[0].poA24)
                        this.POA25Model =  this.readPOA(this.ReadICD10Codes[0].poA25)
                    }
                }).catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                })
        },

        populateICD10(data) {
            this.ICD10.DoctorCode = data.doctorCode ? data.doctorCode.trim() : 'BLANK'
            this.ICD10.DiagCode1 = data.diagCode1 ? data.diagCode1.trim() : null
            this.ICD10.DiagCode2 = data.diagCode2 ? data.diagCode2.trim() : null
            this.ICD10.DiagCode3 = data.diagCode3 ? data.diagCode3.trim() : null
            this.ICD10.DiagCode4 = data.diagCode4 ? data.diagCode4.trim() : null
            this.ICD10.DiagCode5 = data.diagCode5 ? data.diagCode5.trim() : null
            this.ICD10.DiagCode6 = data.diagCode6 ? data.diagCode6.trim() : null
            this.ICD10.DiagCode7 = data.diagCode7 ? data.diagCode7.trim() : null
            this.ICD10.DiagCode8 = data.diagCode8 ? data.diagCode8.trim() : null
            this.ICD10.DiagCode9 = data.diagCode9 ? data.diagCode9.trim() : null
            this.ICD10.DiagCode10 = data.diagCode10 ? data.diagCode10.trim() : null
            this.ICD10.DiagCode11 = data.diagCode11 ? data.diagCode11.trim() : null
            this.ICD10.DiagCode12 = data.diagCode12 ? data.diagCode12.trim() : null
            this.ICD10.DiagCode13 = data.diagCode13 ? data.diagCode13.trim() : null
            this.ICD10.DiagCode14 = data.diagCode14 ? data.diagCode14.trim() : null
            this.ICD10.DiagCode15 = data.diagCode15 ? data.diagCode15.trim() : null
            this.ICD10.DiagCode16 = data.diagCode16 ? data.diagCode16.trim() : null
            this.ICD10.DiagCode17 = data.diagCode17 ? data.diagCode17.trim() : null
            this.ICD10.DiagCode18 = data.diagCode18 ? data.diagCode18.trim() : null
            this.ICD10.DiagCode19 = data.diagCode19 ? data.diagCode19.trim() : null
            this.ICD10.DiagCode20 = data.diagCode20 ? data.diagCode20.trim() : null
            this.ICD10.DiagCode21 = data.diagCode21 ? data.diagCode21.trim() : null
            this.ICD10.DiagCode22 = data.diagCode22 ? data.diagCode22.trim() : null
            this.ICD10.DiagCode23 = data.diagCode23 ? data.diagCode23.trim() : null
            this.ICD10.DiagCode24 = data.diagCode24 ? data.diagCode24.trim() : null
            this.ICD10.DiagCode25 = data.diagCode25 ? data.diagCode25.trim() : null
            this.ICD10.POA1 = data.poA1 ? data.poA1.trim() : null
            this.ICD10.POA2 = data.poA2 ? data.poA2.trim() : null
            this.ICD10.POA3 = data.poA3 ? data.poA3.trim() : null
            this.ICD10.POA4 = data.poA4 ? data.poA4.trim() : null
            this.ICD10.POA5 = data.poA5 ? data.poA5.trim() : null
            this.ICD10.POA6 = data.poA6 ? data.poA6.trim() : null
            this.ICD10.POA7 = data.poA7 ? data.poA7.trim() : null
            this.ICD10.POA8 = data.poA8 ? data.poA8.trim() : null
            this.ICD10.POA9 = data.poA9 ? data.poA9.trim() : null
            this.ICD10.POA10 = data.poA10 ? data.poA10.trim() : null
            this.ICD10.POA11 = data.poA11 ? data.poA11.trim() : null
            this.ICD10.POA12 = data.poA12 ? data.poA12.trim() : null
            this.ICD10.POA13 = data.poA13 ? data.poA13.trim() : null
            this.ICD10.POA14 = data.poA14 ? data.poA14.trim() : null
            this.ICD10.POA15 = data.poA15 ? data.poA15.trim() : null
            this.ICD10.POA16 = data.poA16 ? data.poA16.trim() : null
            this.ICD10.POA17 = data.poA17 ? data.poA17.trim() : null
            this.ICD10.POA18 = data.poA18 ? data.poA18.trim() : null
            this.ICD10.POA19 = data.poA19 ? data.poA19.trim() : null
            this.ICD10.POA20 = data.poA20 ? data.poA20.trim() : null
            this.ICD10.POA21 = data.poA21 ? data.poA21.trim() : null
            this.ICD10.POA22 = data.poA22 ? data.poA22.trim() : null
            this.ICD10.POA23 = data.poA23 ? data.poA23.trim() : null
            this.ICD10.POA24 = data.poA24 ? data.poA24.trim() : null
            this.ICD10.POA25 = data.poA25 ? data.poA25.trim() : null
        },

        getAllDescription(Codes){
            if(Codes.diagCode1 != '' || Codes.diagCode1 != null){
                this.getDescriptionByConditionCode(Codes.diagCode1,'diagCode1');
            }if(Codes.diagCode2 != '' || Codes.diagCode2 != null){
                this.getDescriptionByConditionCode(Codes.diagCode2,'diagCode2');
            }if(Codes.diagCode3 != '' || Codes.diagCode3 != null){
                this.getDescriptionByConditionCode(Codes.diagCode3,'diagCode3');
            }if(Codes.diagCode4 != '' || Codes.diagCode4 != null){
                this.getDescriptionByConditionCode(Codes.diagCode4,'diagCode4');
            }if(Codes.diagCode5 != '' || Codes.diagCode5 != null){
                this.getDescriptionByConditionCode(Codes.diagCode5,'diagCode5');
            }if(Codes.diagCode6 != '' || Codes.diagCode6 != null){
                this.getDescriptionByConditionCode(Codes.diagCode6,'diagCode6');
            }if(Codes.diagCode7 != '' || Codes.diagCode7 != null){
                this.getDescriptionByConditionCode(Codes.diagCode7,'diagCode7');
            }if(Codes.diagCode8 != '' || Codes.diagCode8 != null){
                this.getDescriptionByConditionCode(Codes.diagCode8,'diagCode8');
            }if(Codes.diagCode9 != '' || Codes.diagCode9 != null){
                this.getDescriptionByConditionCode(Codes.diagCode9,'diagCode9');
            }if(Codes.diagCode10 != '' || Codes.diagCode10 != null){
                this.getDescriptionByConditionCode(Codes.diagCode10,'diagCode10');
            }if(Codes.diagCode11 != '' || Codes.diagCode11 != null){
                this.getDescriptionByConditionCode(Codes.diagCode11,'diagCode11');
            }if(Codes.diagCode12 != '' || Codes.diagCode12 != null){
                this.getDescriptionByConditionCode(Codes.diagCode12,'diagCode12');
            }if(Codes.diagCode13 != '' || Codes.diagCode13 != null){
                this.getDescriptionByConditionCode(Codes.diagCode13,'diagCode13');
            }if(Codes.diagCode14 != '' || Codes.diagCode14 != null){
                this.getDescriptionByConditionCode(Codes.diagCode14,'diagCode14');
            }if(Codes.diagCode15 != '' || Codes.diagCode15 != null){
                this.getDescriptionByConditionCode(Codes.diagCode15,'diagCode15');
            }if(Codes.diagCode16 != '' || Codes.diagCode16 != null){
                this.getDescriptionByConditionCode(Codes.diagCode16,'diagCode16');
            }if(Codes.diagCode17 != '' || Codes.diagCode17 != null){
                this.getDescriptionByConditionCode(Codes.diagCode17,'diagCode17');
            }if(Codes.diagCode18 != '' || Codes.diagCode18 != null){
                this.getDescriptionByConditionCode(Codes.diagCode18,'diagCode18');
            }if(Codes.diagCode19 != '' || Codes.diagCode19 != null){
                this.getDescriptionByConditionCode(Codes.diagCode19,'diagCode19');
            }if(Codes.diagCode20 != '' || Codes.diagCode20 != null){
                this.getDescriptionByConditionCode(Codes.diagCode20,'diagCode20');
            }if(Codes.diagCode21 != '' || Codes.diagCode21 != null){
                this.getDescriptionByConditionCode(Codes.diagCode21,'diagCode21');
            }if(Codes.diagCode22 != '' || Codes.diagCode22 != null){
                this.getDescriptionByConditionCode(Codes.diagCode22,'diagCode22');
            }if(Codes.diagCode23 != '' || Codes.diagCode23 != null){
                this.getDescriptionByConditionCode(Codes.diagCode23,'diagCode23');
            }if(Codes.diagCode24 != '' || Codes.diagCode24 != null){
                this.getDescriptionByConditionCode(Codes.diagCode24,'diagCode24');
            }if(Codes.diagCode25 != '' || Codes.diagCode25 != null){
                this.getDescriptionByConditionCode(Codes.diagCode25,'diagCode25');
            }
        },

        getDescriptionByConditionCode(code,ConditionNumber){
           code = code ? code.trim() : null
           if(code != null && code != ''){
           ChargeSheetService.getConditionByCode(this.version, code)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){
                        this.TempConditionByCode = response.data;
                      switch (ConditionNumber) {
                            case "diagCode1":
                                this.admittingCode = code
                                this.admittingDescription = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj1Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode2":
                                this.primaryCode = code
                                this.primaryDescription = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj2Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode3":
                                this.otherDiagnosis1Code = code
                                this.otherDiagnosis1Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj3Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode4":
                                this.otherDiagnosis2Code = code
                                this.otherDiagnosis2Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj4Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode5":
                                this.otherDiagnosis3Code = code
                                this.otherDiagnosis3Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj5Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode6":
                                this.otherDiagnosis4Code = code
                                this.otherDiagnosis4Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj6Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode7":
                                this.otherDiagnosis5Code = code
                                this.otherDiagnosis5Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj7Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode8":
                                this.otherDiagnosis6Code = code
                                this.otherDiagnosis6Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj8Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode9":
                                this.otherDiagnosis7Code = code
                                this.otherDiagnosis7Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj9Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode10":
                                this.otherDiagnosis8Code = code
                                this.otherDiagnosis8Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj10Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode11":
                                this.otherDiagnosis9Code = code
                                this.otherDiagnosis9Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj11Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode12":
                                this.otherDiagnosis10Code = code
                                this.otherDiagnosis10Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj12Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode13":
                                this.otherDiagnosis11Code = code
                                this.otherDiagnosis11Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj13Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode14":
                                this.otherDiagnosis12Code = code
                                this.otherDiagnosis12Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj14Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode15":
                                this.otherDiagnosis13Code = code
                                this.otherDiagnosis13Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj15Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode16":
                                this.otherDiagnosis14Code = code
                                this.otherDiagnosis14Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj16Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode17":
                                this.otherDiagnosis15Code = code
                                this.otherDiagnosis15Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj17Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode18":
                                this.otherDiagnosis16Code = code
                                this.otherDiagnosis16Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj18Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode19":
                                this.otherDiagnosis17Code = code
                                this.otherDiagnosis17Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj19Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode20":
                                this.otherDiagnosis18Code = code
                                this.otherDiagnosis18Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj20Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode21":
                                this.otherDiagnosis19Code = code
                                this.otherDiagnosis19Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj21Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode22":
                                this.otherDiagnosis20Code = code
                                this.otherDiagnosis20Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj22Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode23":
                                this.otherDiagnosis21Code = code
                                this.otherDiagnosis21Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj23Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            case "diagCode24":
                                this.otherDiagnosis22Code = code
                                this.otherDiagnosis22Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj24Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                                break;
                            default:
                                this.otherDiagnosis23Code = code
                                this.otherDiagnosis23Description = this.TempConditionByCode[0] ? this.TempConditionByCode[0].dName : null;
                                this.adj25Model = this.TempConditionByCode[0] ? this.TempConditionByCode[0].adjustment : null;
                      }
                    }
                 })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
           }

        },

        async getDoctorByCode(code){
           code = code ? code.trim() : null
           if(code != null && code != ''){
           await ChargeSheetService.getDoctorByCode(code)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        let doctor = response.data;
                        this.doctorCode = code
                        this.doctorDesc = `${doctor.firstname} ${doctor.lastname}`
                    }
                 })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
           }
        },

        async GetAddtInfo(){
           await ChargeSheetService.GetAddtInfo(this.patientCode, this.recordId)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        this.AddtInfo = response.data;
                        this.LOSModel = this.AddtInfo.los
                        this.AgeADJModel = this.AddtInfo.ageAdj
                        this.CoveredChargesModel = this.AddtInfo.coveredCharges
                    }
                 })
                .catch((error) => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });
        },

        async getReadICD10Codes() {
            await this.GetChargeSheetReadICD10Codes()
            this.getAllDescription(this.ReadICD10Codes[0])
            this.populateICD10(this.ReadICD10Codes[0])
            await this.getDoctorByCode(this.ReadICD10Codes[0].doctorCode)
        }

      },

      created() {
      },

      async mounted(){
        await this.GetPatientByCode()
        await this.GetChargeSheet()
        await this.ChargeSheetIsIDC9()
        await this.GetIPFcomoadjustment()
        await this.GetIPFDrgAdjustment()
        await this.getReadICD10Codes()
        await this.GetAddtInfo()
      }
    };
</script>
